import { observer } from "mobx-react";
import React from "react";
import './text-banner.scss';

export const enum TEXT_BANNER_VARIANTS {
    DEFAULT = 'defaultr',
    GRADIENT = 'gradient',
}

interface ITextbannerProps {
    children: React.ReactNode;
    variant?: TEXT_BANNER_VARIANTS;
    backgroundImage?: string;
}

const TextBanner: React.FC<ITextbannerProps> = observer(({children, variant = TEXT_BANNER_VARIANTS.GRADIENT, backgroundImage}) => {
    const style: React.CSSProperties = {};
    if (backgroundImage) {
        style.backgroundImage = `url('${backgroundImage}')`;
        style.backgroundSize = 'cover';
    }

    return (
        <div className={`sbr-page-text-banner text-banner--${variant}`} style={style}>
            <div className={`text-banner-content`}>{children}</div>
        </div>
    )
});

export default TextBanner;